import React from "react";

const NoResults = ({ icon, t }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: "5em",
      }}
    >
      <img src={icon} alt="No Result" width="35px" />
      <p
        style={{
          color: "#333333",
          fontSize: "14px",
          lineHeight: "19px",
          textAlign: "center",
          padding: "20px 10px",
          fontWeight: "500",
        }}
      >
        {t("Sorry.")} <br />
        {t("No result for your criteria.")} <br />
        {t("Try to refine your search or enter a new ")} <br />
      </p>
    </div>
  );
};

export default NoResults;
